<template>
  <v-slide-y-transition>
    <v-toolbar dark class="image-action-bar justify-space-between" dense flat>
      <select
        v-if="history"
        class="version-select"
        @change="e => $router.push({ query: { ...$route.query, version: e.target.value } })"
      >
        <option
          v-for="(entry, index) in historyArray
            .filter(i => i.id)
            .slice()
            .reverse()"
          :key="index"
          :value="entry.id"
          :selected="entry.id === ($route.query.version || active.asset.activeId)"
        >
          {{ entry.updatedAt | time }} - v{{ entry.semVersion || historyArray.length - index }} by
          {{ entry.updatedBy ? entry.updatedBy.name : 'Not tracked' }}
        </option>
      </select>
      <!-- <div
        class="ml-3"
        v-if="$route.query.version && ($route.query.version !== active.asset.activeId)"
      >
        <v-btn @click.stop="setVersionActive($route.query.version)" text>Set Version Active</v-btn>
      </div>-->
      <v-spacer />
      <v-btn text color="white" @click.prevent="toggleShowTaskOverlay">
        {{ showOverlay ? 'Hide' : 'Show' }} Tasks
      </v-btn>
      <v-btn icon @click="toggleInteractionMode">
        <v-icon :color="interactionMode ? 'primary' : ''">
          {{ icons.interaction }}
        </v-icon>
      </v-btn>
      <v-dialog v-model="open" fullscreen transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>{{ icons.comment }}</v-icon>
          </v-btn>
        </template>

        <!--
        <task-comment-screen :src="src"/>
        -->
        <editor @close="onClose" />
      </v-dialog>
    </v-toolbar>
  </v-slide-y-transition>
</template>

<script>
import TaskCommentScreen from '@/components/annotation-modal/full-screen-modal/TaskCommentScreen';
import Editor from '@/components/slides/editor';
import { TOGGLE_INTERACTION_MODE } from '@/config/constants';
import { mapState } from 'vuex';
import icons from '../../mixins/icons';
import moment from 'moment';

export default {
  name: 'ImageActionBar',
  components: {
    TaskCommentScreen,
    Editor
  },
  filters: {
    time(e) {
      if (moment(e).isValid()) {
        return moment(e).format('DD.MM.YY - kk:mm');
      } else {
        return e;
      }
    },
    reverse(value) {
      return value.slice().reverse();
    }
  },
  mixins: [icons],
  props: {
    hover: Boolean,
    src: String,
    history: Array
  },
  data() {
    return {
      open: false
    };
  },
  watch: {
    open(val) {
      return val;
    }
  },
  computed: {
    ...mapState('slides', {
      active: state => state.active
    }),
    ...mapState('interactions', {
      interactionMode: state => state.interactionMode
    }),
    ...mapState('tasks', {
      showOverlay: state => state.behavior.showTasksOverlay
    }),
    historyArray() {
      const history = _.cloneDeep(this.history);
      if (history.filter(i => i.id === this.active.asset.activeId).length === 0) {
        const currentVersion = {
          semVersion: this.active.asset.currentVersion.semVersion,
          id: this.active.asset.currentVersion.id,
          updatedAt: this.active.asset.currentVersion.at || 'latest',
          updatedBy: this.active.asset.currentVersion.by || null
        };
        history.push(currentVersion);
      }
      return history;
    }
  },
  methods: {
    setVersionActive(version) {
      return this.$store.dispatch('slides/resetVersion', version);
    },
    onClose() {
      this.open = false;
    },
    toggleShowTaskOverlay(value) {
      localStorage.setItem('task-overlay', !this.showOverlay);
      this.$store.commit('tasks/toggleShowTaskOverlay');
    },
    toggleInteractionMode() {
      return this.$store.commit(TOGGLE_INTERACTION_MODE);
    }
  }
};
</script>

<style scoped>
.version-select {
  /* border: 1px solid var(--new-blue); */
}
.image-action-bar {
  position: relative;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
}
</style>
